<template>
    <div class="box">
        <el-form label-width="auto">

            <SectionTitle title="基础信息" />
            <el-form-item label="标题">
                <el-input v-model="myObj.bottom_list_tagsandphotos_params.title" placeholder="请输入"></el-input>
            </el-form-item>

            <SectionTitle title="数据选择" />
            <el-form-item label="大栏目">
                <el-autocomplete clearable v-model="queryCategory" :fetch-suggestions="querySearchCategory"
                    placeholder="搜索/选择大栏目" @select="(item) => handleSelectCategory(item)"></el-autocomplete>
            </el-form-item>
            <el-form-item label="标签组">
                <el-autocomplete clearable v-model="queryTagGroup" :fetch-suggestions="querySearchTagGroup"
                    placeholder="搜索/选择标签组" @select="(item) => handleSelectTagGroup(item)"></el-autocomplete>
            </el-form-item>
            <el-form-item label="每页个数">
                <el-input-number v-model="myObj.source_list.params.per_page" :min="1"></el-input-number>
            </el-form-item>

            <SectionTitle title="样式设置" />


            <el-form-item label="左右间距">
                <el-input-number v-model="myObj.bottom_list_tagsandphotos_params.margin" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素间距">
                <el-input-number v-model="myObj.bottom_list_tagsandphotos_params.between_space"
                    :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素圆角">
                <el-input-number v-model="myObj.bottom_list_tagsandphotos_params.corner_radius"
                    :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素宽">
                <el-input-number v-model="myObj.bottom_list_tagsandphotos_params.item_width" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素高">
                <el-input-number v-model="myObj.bottom_list_tagsandphotos_params.item_height"
                    :min="0"></el-input-number>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import { GetAtlasCategoryList, GetAtlasTagGroup } from '@/request/api'

import SectionTitle from '@/components/SectionTitle.vue';
export default {
    name: "BottomListWallpaperProp",
    components: {
        SectionTitle
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
            showTypeOptions: [
                { name: '图片列表样式', value: 'photolist' },
                { name: '瀑布流样式', value: 'waterfall' }],
            queryCategory: '',
            queryTagGroup: ''
        }
    },
    mounted() {
        this.queryCategory = this.myObj.source_list.ignore.category_name
        this.queryTagGroup = this.myObj.source_list.ignore.tag_group_name
    },
    methods: {
        /**
         * 查询大栏目
         */
        querySearchCategory(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasCategoryList(params)
                .then(data => {
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.categoryID
                        }
                    })
                    cb(list)
                })
        },
        /**
        * 查询标签组
        */
        querySearchTagGroup(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasTagGroup(params)
                .then(data => {
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.groupID
                        }
                    })
                    cb(list)
                })
        },
        handleSelectCategory(item) {
            this.queryStringCategory = item.value
            this.myObj.source_list.params.category_id = item.id
            //辅助回显信息
            this.myObj.source_list.ignore.category_name = item.value
        },
        handleSelectTagGroup(item) {
            this.queryStringTag = item.value
            this.myObj.source_list.params.tag_group_id = item.id
            //辅助回显信息
            this.myObj.source_list.ignore.tag_group_name = item.value
        },
    }
}
</script>

<style scoped lang="less">
.box {
    padding: 15px;
}
</style>